<script lang="ts" setup>
import {useTranslation} from "i18next-vue";
import Dialog from 'primevue/dialog'
import {ref} from 'vue'

import HelpForm from '@/components/site/HelpForm.vue'
import SiteFooter from '@/layouts/site/SiteFooter.vue'

const showHelpModal = ref(false)
const { t } = useTranslation()
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <main class="flex-1 bg-neutral-100 flex items-center justify-center">
      <RouterView />
      <Button
        rounded
        raised
        class="floating-help-widget fixed bottom-4 right-4 z-50"
        icon="pi pi-question-circle"
        :label="t('common:help.title')"
        @click="showHelpModal = true"
      />
    </main>
    <Dialog
      v-model:visible="showHelpModal"
      :breakpoints="{'960px': '75vw','640px': '90vw'}"
      :close-on-escape="true"
      class="w-[35rem]"
      :header="t('common:help.form-title')"
      dismissable-mask
      modal
    >
      <p class="mb-8">{{ t('common:help.form-text') }}</p>
      <HelpForm v-if="showHelpModal" @close="showHelpModal = false" />
    </Dialog>
    <SiteFooter />
  </div>
</template>

<style lang="scss" scoped>
.floating-help-widget {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  align-items: center;
  cursor: pointer;
  z-index: 1999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
